export default __webpack_public_path__ + "static/media/BK_97_QT_Header_1.45b4063b.png";